import { type RouteRecordRaw } from 'vue-router'
import { functionRoutes } from './function'

export default [
  {
    path: '/admin',
    component: () => import('layouts/receiver/MainLayout.vue'),
    redirect: '/admin/users',
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      menu: 'admin',
    },
    children: [
      // Function
      ...functionRoutes,
      {
        path: 'import-export',
        redirect: '/admin/import-export/functions',
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
      {
        path: 'import-export/:tab',
        name: 'admin-import-export',
        component: () =>
          import('pages/receiver/admin/importExport/AdminImportExport.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
      {
        path: 'users',
        name: 'admin-manage-admins',
        component: () =>
          import('pages/receiver/admin/user/admin/ManageAdmins.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
        },
      },
      {
        path: 'roles',
        component: () => import('pages/common/RouterView.vue'),
        children: [
          {
            path: '',
            name: 'admin-default-roles',
            component: () =>
              import('pages/receiver/admin/user/roles/ManageDefaultRoles.vue'),
            meta: {
              requiresAuth: true,
              requiresAdmin: true,
            },
          },
          {
            path: 'create',
            name: 'admin-default-roles-create',
            component: () =>
              import('pages/receiver/admin/user/roles/EditDefaultRoles.vue'),
            meta: {
              requiresAuth: true,
              requiresAdmin: true,
            },
          },
          {
            path: 'edit/:id',
            name: 'admin-default-roles-edit',
            component: () =>
              import('pages/receiver/admin/user/roles/EditDefaultRoles.vue'),
            meta: {
              requiresAuth: true,
              requiresAdmin: true,
            },
          },
        ],
      },
      // IMPERSONATE
      {
        path: 'impersonate',
        name: 'admin-impersonate',
        component: () =>
          import('pages/receiver/admin/impersonate/ImpersonatePage.vue'),
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
          oneOfRoles: ['ADMIN_IMPERSONATE_USER', 'ADMIN_IMPERSONATE_CUSTOMER'],
        },
      },
      {
        path: 'billing',
        component: () => import('pages/common/RouterView.vue'),
        redirect: '/admin/billing/services',
        children: [
          {
            path: 'services',
            name: 'admin-billing-services',
            component: () =>
              import('pages/receiver/admin/billing/ManageServices.vue'),
            meta: {
              requiresAuth: true,
              requiresAdmin: true,
            },
          },
          {
            path: 'services/create',
            name: 'admin-billing-service-create',
            component: () =>
              import('pages/receiver/admin/billing/EditService.vue'),
            meta: {
              requiresAuth: true,
              requiresAdmin: true,
            },
          },
          {
            path: 'services/edit/:id',
            name: 'admin-billing-service-edit',
            component: () =>
              import('pages/receiver/admin/billing/EditService.vue'),
            meta: {
              requiresAuth: true,
              requiresAdmin: true,
            },
          },
          {
            path: 'coupons',
            name: 'admin-billing-coupons',
            component: () =>
              import('pages/receiver/admin/billing/coupons/ManageCoupons.vue'),
            meta: {
              requiresAuth: true,
              requiresAdmin: true,
            },
          },
        ],
      },
    ],
  },
] as unknown as RouteRecordRaw[]
